import style from '@/less/main.less';
import { Button, Icon, Modal } from '@/semantic-ui/components';
import { useStores } from '@/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import React from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-semantic-toasts';
import Bulletin from '../Bulletin';

interface OnboardingSubmissionDetailsApproveConfirmationModalProps {
  open: boolean;
  onClose: () => void;
}

export const OnboardingSubmissionDetailsApproveConfirmationModal = observer(
  ({ open, onClose }: OnboardingSubmissionDetailsApproveConfirmationModalProps) => {
    const { temporaryEmployeeStore } = useStores();
    const navigate = useNavigate();

    const handleApprove = async () => {
      if (temporaryEmployeeStore.current) {
        await temporaryEmployeeStore.approve(temporaryEmployeeStore.current.id);

        onClose();
        toast({
          type: 'success',
          icon: 'check circle',
          title: 'Onboarding Submission Approved',
          description: 'The onboarding submission has been approved.',
          time: 5000,
        });
        navigate('/onboarding/submissions/approved');
      }
    };

    return (
      <Modal
        className={style.modal}
        open={open}
        size="tiny"
        closeIcon={<Icon name="close" size="tiny" color="black" />}
        closeOnDimmerClick={false}
        onClose={onClose}
      >
        <Modal.Header>Approve Onboarding Submission</Modal.Header>

        <Modal.Content>
          <Bulletin
            errorMessage={temporaryEmployeeStore.errorMessage}
            isLoading={temporaryEmployeeStore.isLoading}
            handleDismiss={() => {
              temporaryEmployeeStore.clearError();
            }}
          />

          <Modal.Description style={{ marginBottom: 18 }}>
            Are you sure you want to approve {temporaryEmployeeStore.current?.user?.fullName}'s
            onboarding submission? Once you do, you will need to manually add the employee to the
            organization in Quickbooks.
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button color="grey" basic style={{ fontSize: '0.9rem' }} onClick={onClose}>
            Cancel
          </Button>
          <Button color="green" style={{ fontSize: '0.9rem' }} onClick={handleApprove}>
            <FontAwesomeIcon icon={['fas', 'user-plus']} style={{ marginRight: 8 }} />
            Approve Submission
          </Button>
        </Modal.Actions>
      </Modal>
    );
  },
);
